module.exports = __webpack_public_path__ + "img/copy.85049e9e.svg";